const LabelOptions = {
  AUDIO: 'audio',
  CAPTIONS: 'captions',
  QUALITIES: 'qualities'
};

export {LabelOptions};
